var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg3(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 58,
    height: 106,
    viewBox: "0 0 58 106",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_bd_2805_1691)",
    shapeRendering: "geometricPrecision"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.221 32.12H4.701v-8.76c0-11.16 3.96-18.96 19.56-18.96h1.44c15.84 0 20.88 6.24 20.88 18.96v7.44c0 8.76-3.96 13.08-7.68 14.52 3.84 1.08 8.88 4.08 8.88 12.6v17.4c0 12.12-6.24 20.28-20.88 20.28h-2.52c-16.08 0-20.4-8.28-20.4-19.92V62.12h15.12v12.24c0 4.8 1.92 7.44 6.48 7.44 4.32 0 6.12-2.64 6.12-7.44v-15c0-4.32-1.2-5.76-5.52-5.76h-9.72V39.68h8.76c4.32 0 5.64-1.44 5.64-6v-9.24c0-4.68-1.44-7.08-5.88-7.08-4.32 0-5.76 2.4-5.76 7.08v7.68z",
    fill: "#000",
    fillOpacity: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.221 32.12H4.701v-8.76c0-11.16 3.96-18.96 19.56-18.96h1.44c15.84 0 20.88 6.24 20.88 18.96v7.44c0 8.76-3.96 13.08-7.68 14.52 3.84 1.08 8.88 4.08 8.88 12.6v17.4c0 12.12-6.24 20.28-20.88 20.28h-2.52c-16.08 0-20.4-8.28-20.4-19.92V62.12h15.12v12.24c0 4.8 1.92 7.44 6.48 7.44 4.32 0 6.12-2.64 6.12-7.44v-15c0-4.32-1.2-5.76-5.52-5.76h-9.72V39.68h8.76c4.32 0 5.64-1.44 5.64-6v-9.24c0-4.68-1.44-7.08-5.88-7.08-4.32 0-5.76 2.4-5.76 7.08v7.68z",
    stroke: "#fff"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_bd_2805_1691",
    x: -4.519,
    y: -4.1,
    width: 61.8,
    height: 109.2,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_2805_1691"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 3,
    dy: 3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceGraphic",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.75 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "effect1_backgroundBlur_2805_1691",
    result: "effect2_dropShadow_2805_1691"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "effect2_dropShadow_2805_1691",
    result: "shape"
  })))));
}
Svg3.displayName = '3';
export default Svg3;